let apiBaseUrl
const hostname = window && window.location && window.location.hostname
const protocol = window && window.location && window.location.protocol

if(/weldingo\.com$/.test(hostname)) {
  apiBaseUrl = `${protocol}//app.${hostname}`
} else {
  apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000'
}

export const API_BASE_URL = apiBaseUrl

let webSocketApiUrl
if(/weldingo\.com$/.test(hostname)) {
  webSocketApiUrl = `wss://app.${hostname}/cable`
} else {
  webSocketApiUrl = process.env.REACT_APP_WEBSOCKET_API_URL || 'ws://localhost:3334/cable'
}

export const WEBSOCKET_API_URL = webSocketApiUrl



// WEBPACK FOOTER //
// ./src/utils/apiConfig.js